<template lang="pug">
  .course-points-shop

    PromoPopup(
      v-if="shopPromoPopup"
    )
    .course-points-shop__header
      p.course-points-shop__title.main__subtitle
        | История покупок
      .course-points-shop__header-controls-wrap.-start-
        InfoPopup
        .course-points-shop__header-controls
          UiButton.course-points-shop__header-tag(
            @click="openShop"
            color="light"
          )
            Icon.course-points-shop__icon.-arrow-(icon="ui-arrow-left")
            span.course-points-shop__header-tag__highlight  Вернуться к бонусам

    .course-points-shop-orders(v-if="!gettingHistory")
      template(v-if="orders.length")
        .course-points-shop-order(v-for="order in orders" :key="order.id")
          .course-points-shop-order__info
            .course-points-shop-order__date
              p {{getDate(order.createdAt)}}
              p {{getTime(order.createdAt)}}
            .course-points-shop-order__description(v-if="order.price")
              | {{getNoun(order.price, 'Списан', 'Списано', 'Списано')}} {{order.price}} {{getNoun(order.price, 'балл', 'балла', 'баллов')}}
              | за покупку продукта "{{order.name}}"
            .course-points-shop-order__description(v-else)
              | Получен продукт "{{order.name}}"

          p.course-points-shop-order__promocode(
            @click="copyPromocode(order.promocode)"
          )
            | {{order.promocode}}
      .course-points-shop-gift(v-else)
        Gift
        p.course-points-shop-gift__title
          | Вы еще не тратили бонусы
    .course-points-shop-orders(v-else)
      EmptyCard(v-for="n in 3" :key="n")


</template>

<script>
import { mapState } from 'vuex';
import moment from 'moment';
import PromoPopup from '@/views/Courses/PointsShop/layouts/PromoPopup';
import InfoPopup from '../layouts/InfoPopup';
import Gift from '../layouts/icon/UncolordGift';
import EmptyCard from './components/EmptyCard';

export default {
  components: { PromoPopup, InfoPopup, Gift, EmptyCard },
  data: () => ({
    preview: true
  }),
  computed: {
    ...mapState('coursePointsShopHistory', {
      courseName: s => s.data.courseName,
      orders: s => s.data.orders,
      gettingHistory: s => s.meta.gettingHistory
    }),
    ...mapState('coursePointsShop', {
      shopPromoPopup: s => s.meta.shopPromoPopup
    })
  },
  watch: {
    courseName() {
      this.setHeader();
    }
  },
  beforeCreate() {
    this.$store.dispatch('coursePointsShopHistory/getHistory', {
      courseId: this.$route.params.courseId
    });
  },
  mounted() {
    this.setHeader();
  },
  methods: {
    getDate(date) {
      if (date) {
        return moment(date).format('DD MMMM YYYY');
      }
    },
    getTime(date) {
      if (date) {
        return moment(date).format('HH:mm');
      }
    },
    openShop() {
      this.$router.replace({
        path: `/courses/course/${this.$route.params.courseId}/points_shop/shop`
      });
    },
    openPromo() {
      this.$store.dispatch('coursePointsShop/setMeta', {
        path: 'shopPromoPopup',
        value: true
      });
    },
    setHeader() {
      if (this.courseName) {
        this.$store.dispatch('lms/setMultipleData', [
          { path: 'headerTitle', value: `${this.courseName}` },
          {
            path: 'headerPrevLink',
            value: '/courses/course/' + this.$route.params.courseId
          }
        ]);
      }
    },
    getNoun(number, one, two, five) {
      let n = Math.abs(number);
      n %= 100;
      if (n >= 5 && n <= 20) {
        return five;
      }
      n %= 10;
      if (n === 1) {
        return one;
      }
      if (n >= 2 && n <= 4) {
        return two;
      }
      return five;
    },
    copyPromocode(promocode) {
      const dummy = document.createElement('textarea');
      document.body.appendChild(dummy);
      dummy.value = promocode;
      dummy.select();
      document.execCommand('copy');
      document.body.removeChild(dummy);
      this.$store.dispatch(
        'ajax/addMessage',
        { message: 'Промокод скопирован', type: 'success' },
        { root: true }
      );
    }
  }
};
</script>
